/** @format */

import role from "./reducer";

const reducer = role;

export * from "./reducer";
export default reducer;
